import { DestroyRef } from '@angular/core';
import { Subject } from 'rxjs';

export function getDestroySubjectFromRef(destroyRef: DestroyRef): Subject<void> {
  const destroy$: Subject<void> = new Subject<void>();
  destroyRef.onDestroy(() => {
    destroy$.next();
    destroy$.complete();
  });
  return destroy$;
}
